/**
 *
 * Component for Previewing reports
 *
 * @description
 * @author Sneha
 *
 */

import React, { useEffect, useState, useContext } from 'react';

import './report-preview.scss';

import { Card, ReferenceSelect, useTranslation, Button, GlobalContext } from 'soxo-bootstrap-core';

import PdfViewer from '../../../../components/pdf-viewer/pdf-viewer';

import { Samples } from '../../../../models';

import { Checkbox, Form, Skeleton, Empty, message } from 'antd';

import { TemplateMasters, Bills } from '../../../../models';

import axios from 'axios';

/**
 *
 *
 * @param {*} param0
 * @returns
 */
export default function ReportPreview({ billId, downloadFileName, props, patient, onPremiseUrl }) {
    // Variable to store labresults
    const [labResults, setlabResults] = useState([]);

    // // Variable to select all values of labresult
    const [checkAll, setCheckAll] = useState(false);

    const { t, i18n } = useTranslation(); // To Translate to another language

    // Variable to convert BytesArray
    var [byteArray, setByteArray] = useState({});

    //Variable to handle button loading
    const [btnloading, setBtnLoading] = useState(false);

    //Variable to handle publish button loading
    const [publishLoading, setPublishLoading] = useState(false);

    // Variable to disable and enable button
    const [disable, setDisable] = useState(false);

    // Selected template code for API calls (e.g., "VITAMIN")
    const [templateCode, setTemplateCode] = useState();

    // Full template object selected by user
    const [selectedTemplate, setSelectedTemplate] = useState();

    // For showing publish button when report is previewed

    const [showPublishButton, setShowPublishButton] = useState(false);

    // Variable to store selected lab results
    const { settings } = useContext(GlobalContext);

    // Variable to show publish report
    const { showPublishReport: isShowPublishReportBtn, testType, type } = settings?.RPTPUB;

    const [form] = Form.useForm();

    useEffect(() => {
        loadLabResults(billId);
    }, []);

    /**
     * This is done to preview pdf on first load
     */
    useEffect(() => {
        if (labResults && labResults.length > 0 && selectedTemplate) {
            preview(form.getFieldsValue());
        }
    }, [labResults, templateCode, selectedTemplate, disable]);

    /**
     * Load the lab results with bill id
     *
     * @param {*} billId
     */
    async function loadLabResults(billId) {
        Samples.getWithItem(billId).then((result) => {
            setCheckAll(true);
            let isTrue = true;

            result.map((record) => {
                record.selected = isTrue ? true : false;

                return record;
            });

            setlabResults(result);
        });
    }

    /**
     * Listened for toggle of checkbox
     *
     * @param {*} event
     */
    const onCheckAllChange = (event) => {
        setCheckAll(event.target.checked);

        let isTrue = event.target.checked;

        labResults.map((record) => {
            record.selected = isTrue ? true : false;

            return record;
        });

        !isTrue ? setDisable(true) : setDisable(false);

        setlabResults(labResults);
    };

    /**
     * Safely extracts and parses tmpl_otherdetails from any template structure.
     * Returns an object (empty if invalid or missing).
     *
     * @param {object} template - The selected template record.
     * @returns {object} parsed tmpl_otherdetails object.
     */
    function parseTemplateDetails(template) {
        if (!template) return {};

        const templateOtherDetails =
            template?.record?.record?.tmpl_otherdetails || template?.record?.tmpl_otherdetails || template?.tmpl_otherdetails;

        if (!templateOtherDetails) return {};

        try {
            return JSON.parse(templateOtherDetails);
        } catch (err) {
            console.error('Invalid tmpl_otherdetails JSON:', err);
            return {};
        }
    }

    /**
     * Function to preview result
     *
     *
     */
    async function preview(values) {
        // Check Selected Report
        if (!selectedLabResults.length) {
            message.warning(t('Please select at least one test to preview the report.'));
            setByteArray({});
            return;
        }

        if (labResults.length && templateCode) {
            setBtnLoading(true);
            setShowPublishButton(false);

            /**
             * Determines if the selected template is a vitamin report.
             * @param {Object} selectedTemplate - Template object to check.
             * @returns {boolean} True if isVitamin === true, otherwise false.
             */
            const details = parseTemplateDetails(selectedTemplate);
            const isVitamin = details.isVitamin === true;

            let formbody = {
                lab_results: selectedLabResults,
                // id: billId,
                ...(isVitamin ? { id: billId } : { opb_id: billId }),
                uploadFlag: false,
            };

            //If template is selected
            if (values && values.template_code) {
                formbody = {
                    ...formbody,
                    template_code: values.template_code,
                };
            } else {
                //Loading template on preview
                formbody = {
                    ...formbody,
                    template_code: templateCode,
                };
            }
            let payload = {
                method: 'POST',
                responseType: 'blob',
                headers: {
                    db_ptr: props.settings.headers.db_ptr.toString(),
                    Authorization: 'Bearer ' + localStorage.access_token,
                },
            };
            // Samples.getpatientLabResults(formbody).then((result) => {
            //     setBtnLoading(true);

            //     if (result && result.data) {
            //         setBtnLoading(false);
            //         var res = result.data;
            //         // var report = new Blob([res], {

            //         //     type: 'application/pdf',

            //         // });
            //         // let fileURL = URL.createObjectURL(report);

            //         var bytearray = Object.keys(res);
            //         var arrayelement = Object.values(res);

            //         var uint8Array = new Uint8Array(bytearray.length);

            //         for (var i = 0; i < uint8Array.length; i++) {
            //             uint8Array[i] = arrayelement[i];
            //         }

            //         for (var i = 0; i < bytearray; i++) {
            //             var ascii = arrayelement.charCodeAt(i);
            //             uint8Array[i] = ascii;
            //         }

            //         setByteArray({ data: uint8Array });

            //         return uint8Array;
            //     } else {
            //         setByteArray([]);

            //         setBtnLoading(false);
            //     }
            // });

            // Choose endpoint based on report type: vitamin reports use 'reporting/print-preview', others use 'opbill/patient-lab-report'
            let url = process.env.REACT_APP_endpoint + (isVitamin ? `reporting/print-preview` : `opbill/patient-lab-report`);

            await axios
                .post(`${url}`, formbody, payload)

                .then((res) => {
                    setBtnLoading(true);
                    var report = new Blob([res.data], {
                        type: 'application/pdf',
                    });

                    let fileURL = URL.createObjectURL(report);

                    setByteArray({ data: fileURL });

                    setBtnLoading(false);
                    if (isPublishable) {
                        setShowPublishButton(true);
                    }
                })
                .catch(() => {
                    // error: true,

                    // data: null,

                    setBtnLoading(false);
                    setByteArray({ data: null }); //  clear previous report
                });
        }
    }

    if (labResults.length) {
        //Get selected tests
        var selectedLabResults = labResults
            .filter((record) => {
                return record.selected;
            })
            .map((record) => record.lbtrs_id);
    }

    /**
     * Function to toggle state of the lab results
     *
     * @param {*} index
     */
    function selectLabResult(index) {
        labResults[index].selected = !labResults[index].selected;

        setlabResults([...labResults]);

        let enabledResults = labResults.filter((record) => record.selected);

        if (enabledResults.length === labResults.length) {
            setCheckAll(true);
        } else {
            setCheckAll(false);

            setDisable(false);
        }
    }

    /**
     * To publish report
     */

    async function publishReport() {
        setPublishLoading(true);

        //publish report
        let formbody = {
            test_type: testType,
            type: type,
            reference_number: billId,
            lab_results: selectedLabResults,
            mobile: patient.opbill[0].opb_mobile,
            template_code: selectedTemplate.value,
            doc_code: docCode,
        };

        //Upload report to aws
        const res = await Bills.publishReport(onPremiseUrl, formbody);

        setPublishLoading(false);

        if (res?.success === true) {
            message.success('Report Published Successfully');
        } else {
            message.error('Failed to publish report');
        }
    }
    /**
     * if enable the publish report button when isPublishable === true;
     * @param {*} options
     * @returns
     */
    // Derive isPublishable cleanly
    const publishReportButtonEnabled = (template) => {
        const details = parseTemplateDetails(template);
        return details.isPublishable === true;
    };

    const isPublishable = publishReportButtonEnabled(selectedTemplate);

    /**
     * Safely extracts `doc_code` from a template's `tmpl_otherdetails` JSON field.
     * Handles nested structures and invalid JSON gracefully.
     *
     * @param {object} selectedTemplate - The selected template object.
     * @returns {string} Extracted `doc_code` or an empty string if unavailable.
     */
    const { doc_code: docCode = '' } = parseTemplateDetails(selectedTemplate);

    /**
     *  Load default Template
     * @param {*} options
     * @returns
     */
    function identifyDefaultTemplate(options = []) {
        let matching = {};

        //To load lab report as default template
        if (options) {
            options.forEach(async (record) => {
                if (record.tmpl_groupptr === 'BILLRPT' && record.tmpl_desc === 'BILLREPORT') {
                    matching = record;
                }
            });
        }

        if (matching) {
            setTemplateCode(matching.tmpl_code);

            setSelectedTemplate({ value: matching.tmpl_code, record: matching }); //To load lab report as default template

            return matching;
        }
    }
    return (
        <div className="detail-contents">
            <div className="left-sections">
                <div className="top">
                    {labResults?.length > 0 && ( // Check if lab results are available
                        <Card className="card-shadows card">
                            <div className="billd-records">
                                <div className="test-names">
                                    {/* <h2>Test Names</h2> */}
                                    <h5 className="headings-h5">Select All</h5>
                                    <Checkbox disabled={btnloading} checked={checkAll} onChange={onCheckAllChange} className="select-all-checkbox" />
                                </div>

                                {/* Test Names */}
                                {labResults.map((entry, key) => {
                                    return (
                                        <div
                                            className="card-shadow card"
                                            onClick={() => {
                                                selectLabResult(key);
                                            }}
                                        >
                                            <div className="test-names">
                                                <h5 className="headings-h5">{entry.item.itm_desc}</h5>

                                                <Checkbox disabled={btnloading} checked={entry.selected} defaultChecked />
                                            </div>
                                        </div>
                                    );
                                })}
                                {/* Test Names Ends */}
                            </div>
                        </Card>
                    )}
                </div>

                <div className="bottom">
                    <Card className="card-shadow card" loading={() => <Skeleton />}>
                        {/* Preview Action Form */}
                        <Form form={form}>
                            <div>
                                <p>{t('Choose a template')}</p>
                            </div>

                            {/* <div className='labels'>
                                <label>Header Style</label>
                            </div>

                            <Select className='preview-header' placeholder="- Select header style -" /> */}

                            <div className="labels">
                                <label>{t('Template')}</label>
                            </div>

                            <div className="template">
                                <Form.Item name="template_code">
                                    <ReferenceSelect
                                        config={{
                                            queries: [
                                                {
                                                    field: 'tmpl_groupptr',
                                                    value: 'BILLRPT',
                                                },
                                            ],
                                        }}
                                        defaultValueCondition={identifyDefaultTemplate}
                                        field="tmpl_code"
                                        label="tmpl_desc"
                                        mode="nura-base"
                                        model={TemplateMasters}
                                        onChange={(value, record) => {
                                            record && setSelectedTemplate({ value, record });
                                            // Hide publish button on template change
                                            setShowPublishButton(false);
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: '5px' }}>
                                        <Button
                                            disabled={disable}
                                            loading={btnloading}
                                            className="preview-button"
                                            type="primary"
                                            onClick={() => preview(form.getFieldsValue())}
                                        >
                                            {t('Preview')}
                                        </Button>
                                        {/* Show only if publishable is true in template details */}
                                        {isShowPublishReportBtn && isPublishable && (
                                            <Button
                                                // Enable only after preview
                                                disabled={disable || !showPublishButton}
                                                loading={publishLoading}
                                                className="preview-button"
                                                type="primary"
                                                onClick={publishReport}
                                            >
                                                Publish Report
                                            </Button>
                                        )}
                                    </div>
                                </Form.Item>
                            </div>
                        </Form>

                        {/* Preview Action Form */}
                        {/* <Select className='select-action' placeholder="- Select Action -" /> */}
                    </Card>
                </div>
            </div>

            <div className="right-sections">
                {/* Report Preview */}
                {(byteArray.data && byteArray.data.length) || btnloading ? (
                    <div className="report-container">
                        {btnloading ? (
                            <>
                                <Skeleton />
                            </>
                        ) : (
                            <div>
                                {byteArray.data ? <iframe src={byteArray.data} style={{ width: '100%', height: '573px' }} /> : null}
                                {/*  */}

                                {/* <PdfViewer url={byteArray} options={downloadFileName} /> */}
                            </div>
                        )}
                    </div>
                ) : (
                    <Empty />
                )}
                {/* Report Preview Ends */}
            </div>
        </div>
    );
}
